import { render } from "./ServiceAccountForm.vue?vue&type=template&id=2cbc21c8"
import script from "./ServiceAccountForm.vue?vue&type=script&lang=js"
export * from "./ServiceAccountForm.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__